import React from 'react';
import styled from 'styled-components';

import Invoice from '../types/invoice';
import TableRow from './TableRow';
import TableHead from './TableHead';

interface Props {
  invoices: Invoice[];
  onPayInvoice: (invoice: Invoice) => void;
}

const TABLE_HEADERS = ['Date of Service', 'Service', 'Balance', 'Invoice Details', 'Invoice No'];

const Table = ({ invoices, onPayInvoice }: Props) => {
  const emptyState = (
    <EmptyTableRow>
      <td colSpan={TABLE_HEADERS.length}>
        There are currently no invoices on your account. <br />
        We will send you an email if there is any financial activity or please check back at a later
        time.
      </td>
    </EmptyTableRow>
  );

  const rows = invoices.map(invoice => (
    <TableRow key={invoice.id} invoice={invoice} onPayClick={() => onPayInvoice(invoice)} />
  ));

  const isEmpty = rows.length === 0;

  return (
    <TableComponent>
      <thead>
        <tr>
          {TABLE_HEADERS.map(header => (
            <TableHead key={header}>{header}</TableHead>
          ))}
        </tr>
      </thead>

      <TableBody>{isEmpty ? emptyState : rows}</TableBody>
    </TableComponent>
  );
};

const TableComponent = styled.table`
  width: 100%;
  margin-top: 16px;
  border-spacing: 0px;

  th,
  td {
    white-space: nowrap;
  }

  td:nth-child(2) {
    width: 99%;
    white-space: normal;
  }
`;

const TableBody = styled.tbody`
  width: 100%;
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  font-size: 16px;
  line-height: 20px;

  td {
    border: 0.8px solid #f3e7da;
  }
`;

const EmptyTableRow = styled.tr`
  td {
    padding: 48px 0px 60px 0px;
    text-align: center;
  }
`;

export default Table;
